import Empty from 'constants/empty';

const modalsSelector = store => store.modals || Empty.Object;

export default modalsSelector;
